import { type ItineraryResponse, type UnifiedLegDTO, type Location, GeometryType, type UnifiedItineraryDTO, ItineraryType } from '../types/Itinerary';
import { type Leg, type Itinerary } from '../types/TripPlanner';

export function transformItineraryToMyCarCard(data: ItineraryResponse, startDate: number, startLocation: Location, endLocation: Location): UnifiedItineraryDTO | null {
  if (data.paths == null || data.paths.length === 0) {
    return null;
  }

  const path = data.paths[0];

  const startTime = startDate;
  const endTime = startTime + path.time;

  // transform date from timestamp to this : 2024-11-27T12:01:00+01:00

  const startDateISO = new Date(startTime).toISOString();
  const endDateISO = new Date(endTime).toISOString();

  // Creating a single Leg from the path data directly
  const leg: UnifiedLegDTO = {
    mode: 'mycar',
    duration: path.time,
    distance: path.distance,
    startLocation,
    endLocation,
    startTime: startDateISO,
    endTime: endDateISO,
    geometry: path.points,
    geometryType: GeometryType.DEUXD
  };

  return {
    duration: path.time,
    startTime: startDateISO,
    endTime: endDateISO,
    cost: path.price,
    legs: [leg], // An array containing just the single leg
    type: ItineraryType.CAR
  };
}

export function transformItineraries(data: ItineraryResponse, startDate: number): Itinerary[] {
  if (data.paths.length === 0) {
    console.error('Invalid path data');
    return [];
  }

  return data.paths.map((path) => {
    const startTime = startDate;
    const endTime = startTime + path.time;

    const leg: Leg = {
      mode: 'mycar',
      startTime,
      endTime,
      duration: path.time,
      distance: path.distance,
      realTime: false
    };

    return {
      startTime,
      endTime,
      duration: path.time,
      price: path.price,
      legs: [leg],
      points: path.points
    };
  });
}

/**
 * Convertit un type d'itineraire en priorité
 * @param type type d'itinéraire
 */
export function typeToOrder(type: ItineraryType) {
  switch (type) {
    case ItineraryType.GRAPH_HOPPER:
      return 1;
    case ItineraryType.OTP:
      return 2;
    case ItineraryType.BLABLADAILY:
      return 3;
    case ItineraryType.CAR:
      return 4;
  }
}
